<template>
  <v-layout
    style="flex: none;"
    class="home-footer-info"
    @click="editCoordinate"
  >
    <v-layout
      v-if="editingCoordinate"
      style="margin: 0 15px;"
      v-on-clickaway="cancelEdit"
    >
      <label style="margin-right: 5px">{{ labelY }}</label>
      <input
        v-model="yCoordinate"
        type="number"
        id="coordinateY"
        style="width: 60px; background: #e8e8e8 ; margin-right: 15px"
        :class="{ 'required-fail': !validLatitude }"
        :hideArrow="true"
        v-on:keyup.enter="saveCoordinate"
        v-on:keyup.esc="cancelEdit"
      />
      <label style="margin-right: 5px">{{ labelX }}</label>
      <input
        v-model="xCoordinate"
        type="number"
        id="coordinateX"
        style="width: 60px; background: #e8e8e8 ; "
        :class="{ 'required-fail': !validLongitude }"
        :hideArrow="true"
        v-on:keyup.enter="saveCoordinate"
        v-on:keyup.esc="cancelEdit"
      />
    </v-layout>
    <span
      v-show="!editingCoordinate"
      id="mouse-position"
      ref="mouseCoordinates"
    />
  </v-layout>
</template>

<script>
import { bus } from "@/main";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "HomeFooterMouseCoordinates",

  mixins: [clickaway],

  data() {
    return {
      yCoordinate: null,
      xCoordinate: null,
      labelY: null,
      labelX: null,
      width: 565,
      height: 107,
      editingCoordinate: false
    };
  },

  computed: {
    validLatitude() {
      if (this.labelY === "Lat:") {
        return this.yCoordinate >= -90 && this.yCoordinate <= 90;
      } else {
        return true;
      }
    },

    validLongitude() {
      if (this.labelX === "Lon:") {
        return this.xCoordinate >= -180 && this.xCoordinate <= 180;
      } else {
        return true;
      }
    },

    validCoordinates() {
      if (this.labelY === "Lat:" || this.labelX === "Lon:") {
        return this.validLatitude && this.validLongitude;
      } else {
        return true;
      }
    }
  },

  watch: {
    editingCoordinate() {
      if (this.editingCoordinate) {
        this.getCoords();
      }
    }
  },

  methods: {
    editCoordinate() {
      let mouseCoordinates = this.getMouseCoordinates();
      if (!this.editingCoordinate && mouseCoordinates !== "") {
        this.editingCoordinate = true;
      }
    },

    saveCoordinate() {
      if (this.validCoordinates) {
        bus.$emit("change-home-map-coordinate", [
          this.yCoordinate,
          this.xCoordinate
        ]);
        this.editingCoordinate = false;
      }
    },

    getMouseCoordinates() {
      return this.$refs.mouseCoordinates.innerText;
    },

    getCoords() {
      let mouseCoordinates = this.getMouseCoordinates();
      let split = mouseCoordinates.split(" ");
      this.yCoordinate = split[1];
      this.xCoordinate = split[3];

      this.labelY = split[0];
      this.labelX = split[2];
    },

    cancelEdit(event) {
      this.editingCoordinate = false;
    }
  }
};
</script>

<style scoped>
#mouse-position {
  padding: 0 15px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.required-fail {
  border: 1px solid var(--red);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/Coordinates.vue